import React, { useState, useEffect } from "react"
import TemplateWrapperDesktop from "./desktop"
import TemplateWrapperMobile from "./mobile"
import isMobile from "ismobilejs"
import "../style/index.scss"
import CookieConsent, {
  getCookieConsentValue,
  Cookies,
} from "react-cookie-consent"
import * as ReactGA from "react-ga"

const isIpad = uaOriginal => {
  const ua = uaOriginal.toLowerCase()
  return (
    ua.indexOf("ipad") > -1 ||
    (ua.indexOf("macintosh") > -1 && "ontouchend" in document)
  )
}

const TemplateWrapper = props => {
  const [mobileDetected, setMobileDetected] = useState(undefined)

  useEffect(() => {
    setMobileDetected(() => {
      return typeof navigator !== "undefined"
        ? isMobile(navigator.userAgent).any || isIpad(navigator.userAgent)
        : false
    })
  }, [])

  const handleAcceptCookie = () => {
    ReactGA.initialize("UA-102330334- 1")
  }

  const handleDeclineCookie = () => {
    //remove google analytics cookies
    Cookies.remove("_ga")
    Cookies.remove("_gat")
    Cookies.remove("_gid")
  }

  useEffect(() => {
    const isConsent = getCookieConsentValue()
    if (isConsent === "true") {
      handleAcceptCookie()
    }
  }, [])

  if (mobileDetected === undefined) {
    return null
  }

  return (
    <>
      <CookieConsent
        location="bottom"
        onAccept={handleAcceptCookie}
        onDecline={handleDeclineCookie}
        buttonText="Accetta"
        cookieName="myAwesomeCookieName2"
        style={{
          border: "0px solid rgb(255, 255, 255)",
          fontSize: "13px",
          textAlign: "center",
          alignItems: "center",
          float: "left",
          flexDirection: "column",
          backgroundColor: "rgb(255, 255, 255)",
          color: "rgb(10, 10, 10)",
          zIndex: 10000,
          marginBottom: 0,
        }}
        buttonStyle={{
          color: "#FFF",
          backgroundColor: "rgb(0, 0, 0)",
          fontSize: "12px",
          marginTop: 10,
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
        declineButtonStyle={{
          position: "absolute",
          right: 5,
          top: 10,
          color: "#000",
          backgroundColor: "#FFF",
        }}
        declineButtonText={"X"}
        enableDeclineButton
        expires={150}
      >
        <div>
          Questo sito utilizza cookie analytics e di profilazione di terze parti
          per assicurarti la migliore esperienza di navigazione possibile e
          inviarti pubblicità in linea con le tue preferenze.<br /> Se vuoi saperne di
          più sulla tipologia di cookie utilizzata e su come è possibile
          modificare le impostazione{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={'https://www.efficienzaenergetica.edison.it/informativa-cookies/'}
          >
            clicca qui{" "}
          </a>
          . Desideri accettare l'utilizzo dei cookies da parte di questo sito?
        </div>
      </CookieConsent>
      <div
        className={`w-100 h-100 d-flex flex-row justify-content-center align-items-center bg-rotate-message text-white ${
          mobileDetected ? "is-mobile" : ""
        }`}
      >
        <p className="w-50 text-center">
          <p>
            <img src="/Edison_Logo.svg" alt=""></img>
          </p>
          Teniamo all'esperienza dei nostri utenti, per questo ti consigliamo di
          fruire il progetto tramite la visualizzazione verticale
        </p>
      </div>
      <TemplateWrapperDesktop isMobile={mobileDetected} {...props} />
      <TemplateWrapperMobile isMobile={mobileDetected} {...props} />
    </>
  )
}

export default TemplateWrapper
